import React from 'react'
import PropTypes from 'prop-types'

import { cx, utils } from 'passiv-libs'
import { Text, Icon, WavesStatic } from 'passiv-components'

const Heating = ({ loading, name, airTemperature, occupancy }) => {
  return (
    <>
      <Text
        type="title-condensed"
        className="sm:menu-tile-title absolute pt-2 top-0 w-full text-center"
        ariaHidden={true}
      >
        {name}
      </Text>
      {loading || (!loading && !airTemperature) ? (
        <div className="flex-center w-full h-full">
          <Icon className="text-grey w-12 h-9 sm:w-9" icon="menu" />
        </div>
      ) : (
        <Text
          type="large"
          className={cx({
            ['text-in-red']: occupancy[0].type === 'IN',
            ['text-asleep-yellow']: occupancy[0].type === 'ASLEEP',
            ['text-out-grey']: occupancy[0].type === 'OUT',
            ['text-away-grey']: occupancy[0].type === 'VACATION'
          })}
          ariaHidden={true}
        >
          {airTemperature}
        </Text>
      )}
      <WavesStatic
        colour={utils.heating.getOccupancyColour([occupancy])}
        className="absolute bottom-0 -mb-4"
      />
    </>
  )
}

Heating.propTypes = {
  loading: PropTypes.bool,
  name: PropTypes.string,
  airTemperature: PropTypes.string,
  occupancy: PropTypes.array
}

export default Heating
